(function () {
  'use strict';

  var COLORS = {
    VOOWIN: { primary: [255, 90, 0], dark: [17, 17, 17], soft: [255, 244, 238] },
    LITE: { primary: [22, 110, 215], dark: [16, 48, 110], soft: [239, 247, 255] },
    LENSUN: { primary: [126, 153, 211], dark: [18, 25, 42], soft: [241, 244, 252] }
  };

  function clean(value) {
    return String(value || '')
      .replace(/[\u2010-\u2015]/g, '-')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/[^\x20-\x7E\xA0-\xFF]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeBrand(value) {
    var brand = clean(value).toUpperCase();
    if (brand.indexOf('LENSUN') !== -1) return 'LENSUN';
    if (brand.indexOf('LITE') !== -1) return 'LITE';
    return 'VOOWIN';
  }

  function loadImage(url, preserveTransparency) {
    return new Promise(function (resolve) {
      if (!url) return resolve(null);
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = function () {
        try {
          var max = 900;
          var scale = Math.min(1, max / Math.max(image.naturalWidth, image.naturalHeight));
          var canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
          canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
          var context = canvas.getContext('2d');
          if (!preserveTransparency) {
            context.fillStyle = '#ffffff';
            context.fillRect(0, 0, canvas.width, canvas.height);
          }
          context.drawImage(image, 0, 0, canvas.width, canvas.height);
          resolve({
            data: preserveTransparency ? canvas.toDataURL('image/png') : canvas.toDataURL('image/jpeg', 0.84),
            format: preserveTransparency ? 'PNG' : 'JPEG',
            width: canvas.width,
            height: canvas.height
          });
        } catch (error) {
          resolve(null);
        }
      };
      image.onerror = function () { resolve(null); };
      image.src = url;
    });
  }

  function drawImageFit(doc, image, x, y, w, h) {
    if (!image) return;
    var ratio = Math.min(w / image.width, h / image.height);
    var drawW = image.width * ratio;
    var drawH = image.height * ratio;
    doc.addImage(image.data, image.format || 'JPEG', x + (w - drawW) / 2, y + (h - drawH) / 2, drawW, drawH);
  }

  function addCover(doc, total, logos) {
    var orange = COLORS.VOOWIN.primary;
    doc.setFillColor(255, 255, 255);
    doc.rect(0, 0, 210, 297, 'F');
    doc.setFillColor.apply(doc, orange);
    doc.rect(0, 0, 210, 9, 'F');
    doc.rect(0, 289, 210, 8, 'F');
    drawImageFit(doc, logos.VOOWIN, 57, 27, 96, 62);
    doc.setTextColor.apply(doc, COLORS.VOOWIN.dark);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(31);
    doc.text('CATALOGO DIGITAL', 105, 120, { align: 'center' });
    doc.setTextColor.apply(doc, orange);
    doc.setFontSize(14);
    doc.text('REPUBLICA DOMINICANA', 105, 135, { align: 'center' });
    doc.setDrawColor.apply(doc, orange);
    doc.setLineWidth(1);
    doc.line(78, 146, 132, 146);
    doc.setTextColor(80, 80, 80);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(11);
    doc.text('Tecnologia que se mueve contigo', 105, 162, { align: 'center' });
    doc.setFontSize(9);
    doc.text('Productos, soluciones y tecnologia para tu negocio.', 105, 174, { align: 'center' });
    doc.setFillColor(248, 248, 248);
    doc.roundedRect(25, 199, 160, 52, 6, 6, 'F');
    doc.setTextColor(105, 105, 105);
    doc.setFontSize(7.5);
    doc.text('MARCAS DEL CATALOGO', 105, 212, { align: 'center' });
    drawImageFit(doc, logos.LITE, 48, 220, 48, 20);
    drawImageFit(doc, logos.LENSUN, 114, 220, 48, 20);
    doc.setTextColor.apply(doc, COLORS.VOOWIN.dark);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.text(total + ' productos disponibles', 105, 267, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(105, 105, 105);
    doc.text('Catalogo informativo sin precios  |  voowinrd.com', 105, 276, { align: 'center' });
  }

  function addPageBranding(doc, brand, logo, pageNumber) {
    var palette = COLORS[brand];
    doc.setFillColor.apply(doc, palette.primary);
    doc.rect(0, 0, 210, 13, 'F');
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(10, 16, 190, 15, 3, 3, 'F');
    drawImageFit(doc, logo, 15, 18, 45, 11);
    doc.setTextColor.apply(doc, palette.dark);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text('CATALOGO ' + brand, 195, 25, { align: 'right' });
    doc.setTextColor(105, 105, 105);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7.5);
    doc.text('VOOWIN RD  |  voowinrd.com', 11, 291);
    doc.text(String(pageNumber), 199, 291, { align: 'right' });
  }

  function drawPlaceholder(doc, x, y, w, h, brand, logo) {
    var palette = COLORS[brand];
    doc.setFillColor.apply(doc, palette.soft);
    doc.roundedRect(x, y, w, h, 3, 3, 'F');
    if (logo) drawImageFit(doc, logo, x + 10, y + 7, w - 20, h - 18);
    doc.setTextColor.apply(doc, palette.dark);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(6.5);
    doc.text('Imagen pendiente', x + w / 2, y + h - 5, { align: 'center' });
  }

  function drawProduct(doc, product, image, x, y, w, h, brand, logo) {
    var palette = COLORS[brand];
    doc.setDrawColor(225, 225, 225);
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(x, y, w, h, 4, 4, 'FD');
    doc.setFillColor.apply(doc, palette.primary);
    doc.roundedRect(x, y, w, 3, 3, 3, 'F');

    var imageX = x + 5;
    var imageY = y + 6;
    var imageW = w - 10;
    var imageH = 31;
    if (image) drawImageFit(doc, image, imageX, imageY, imageW, imageH);
    else drawPlaceholder(doc, imageX, imageY, imageW, imageH, brand, logo);

    var textY = y + 43;
    var category = clean(product.category || 'Otros').toUpperCase();
    doc.setFillColor.apply(doc, palette.soft);
    doc.roundedRect(x + 5, textY - 4, Math.min(w - 10, 12 + category.length * 1.8), 6, 2, 2, 'F');
    doc.setTextColor.apply(doc, palette.dark);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(6.2);
    doc.text(category, x + 8, textY);

    doc.setTextColor(18, 18, 18);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9.2);
    var nameLines = doc.splitTextToSize(clean(product.name), w - 12).slice(0, 2);
    doc.text(nameLines, x + 6, textY + 8);
    var cursor = textY + 8 + nameLines.length * 4.2;

    if (product.sku) {
      doc.setTextColor(95, 95, 95);
      doc.setFontSize(6.5);
      doc.text('REF: ' + clean(product.sku), x + 6, cursor + 1);
      cursor += 5;
    }

    var description = clean(product.description);
    if (description) {
      doc.setTextColor(95, 95, 95);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(6.5);
      doc.text(doc.splitTextToSize(description, w - 12).slice(0, 3), x + 6, cursor + 1);
    }

    doc.setTextColor.apply(doc, palette.primary);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(6.5);
    doc.text('VER FICHA', x + 6, y + h - 5);
    if (product.url) doc.link(x + 4, y + h - 12, w - 8, 10, { url: product.url });
  }

  async function generate(button) {
    var status = button.parentElement.querySelector('[data-vrd-pdf-status]');
    var dataElement = document.getElementById(button.getAttribute('data-catalog-data'));
    if (!dataElement || !window.jspdf || !window.jspdf.jsPDF) {
      if (status) status.textContent = 'No fue posible iniciar el PDF. Actualiza la pagina.';
      return;
    }

    var products;
    try {
      products = JSON.parse(dataElement.textContent);
    } catch (error) {
      if (status) status.textContent = 'No fue posible leer los productos.';
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Cargando identidad de las marcas...';

    try {
      var logoResults = await Promise.all([
        loadImage(button.dataset.logoVoowin, true),
        loadImage(button.dataset.logoVoowinCover, true),
        loadImage(button.dataset.logoLite, true),
        loadImage(button.dataset.logoLensun, true)
      ]);
      var logos = {
        VOOWIN: logoResults[0],
        VOOWIN_COVER: logoResults[1],
        LITE: logoResults[2],
        LENSUN: logoResults[3]
      };

      var grouped = { VOOWIN: [], LITE: [], LENSUN: [] };
      products.forEach(function (product) {
        product.normalizedBrand = normalizeBrand(product.brand);
        grouped[product.normalizedBrand].push(product);
      });
      Object.keys(grouped).forEach(function (brand) {
        grouped[brand].sort(function (a, b) {
          var byCategory = clean(a.category).localeCompare(clean(b.category), 'es', { sensitivity: 'base' });
          return byCategory || clean(a.name).localeCompare(clean(b.name), 'es', { sensitivity: 'base' });
        });
      });

      var doc = new window.jspdf.jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait', compress: true });
      addCover(doc, products.length, logos);
      var pageNumber = 1;
      var processed = 0;
      var brandOrder = ['VOOWIN', 'LITE', 'LENSUN'];
      var positions = [[12, 36], [106, 36], [12, 119], [106, 119], [12, 202], [106, 202]];

      for (var g = 0; g < brandOrder.length; g += 1) {
        var brand = brandOrder[g];
        var brandProducts = grouped[brand];
        if (!brandProducts.length) continue;
        for (var i = 0; i < brandProducts.length; i += 6) {
          doc.addPage();
          pageNumber += 1;
          addPageBranding(doc, brand, logos[brand], pageNumber);
          var batch = brandProducts.slice(i, i + 6);
          var images = [];
          for (var b = 0; b < batch.length; b += 1) {
            images.push(await loadImage(batch[b].image));
            processed += 1;
            if (status) status.textContent = 'Preparando ' + processed + ' de ' + products.length + ' productos...';
          }
          for (var p = 0; p < batch.length; p += 1) {
            drawProduct(doc, batch[p], images[p], positions[p][0], positions[p][1], 92, 78, brand, logos[brand]);
          }
        }
      }

      var date = new Date();
      var stamp = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      doc.save('Catalogo-VOOWIN-RD-' + stamp + '.pdf');
      if (status) status.textContent = 'Catalogo actualizado descargado.';
    } catch (error) {
      console.error('VOOWIN PDF:', error);
      if (status) status.textContent = 'Ocurrio un error al crear el PDF. Intenta nuevamente.';
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  function bind(scope) {
    (scope || document).querySelectorAll('[data-vrd-pdf-download]:not([data-vrd-pdf-ready])').forEach(function (button) {
      button.setAttribute('data-vrd-pdf-ready', 'true');
      button.addEventListener('click', function () { generate(button); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }
  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
}());
